/**
 * Created by jonas on 2021-02-02.
 */

export class MatrixUtils {
    /**
     * Makes a deep copy of input matrix.
     * @param input
     */
    public static cloneMatrix(input:any[][]):any[][] {
        const result = [];
        for(let column of input) {
            result.push([...column]);
        }
        return result;
    }


    /**
     * Returns array of positions ([number,number] -> columns,row) where it matches callback condition.
     * @param matrix
     * @param callback
     */
    public static getPositionsWhere(matrix:any[][], callback:(value:any, column?:number, row?:number) => boolean):[number, number][] {
        const result:[number, number][] = [];
        for(let i:number = 0; i < matrix.length; i++) {
            for(let j:number = 0; j < matrix[i].length; j++) {
                if(callback(matrix[i][j], i, j)) {
                    result.push([i, j]);
                }

            }
        }
        return result;
    }


}

